<template>
	<div class="supplier">
		<Navbar />
	</div>
</template>

<script>
import Navbar from '@/components/supplier/Navbar';

export default {
	components: {
		Navbar
	},
	created() {
	}

}

</script>